// Convierte un string en array de React nodes detectando URLs, hashtags y
// links de invitación a canales (formato: dominio/c/CÓDIGO).
import React from 'react';

// Token combinado: URL, hashtag. Se evalúan por orden de alternativa.
// URL: http(s):// o www. hasta antes de puntuación final
// Hashtag: # seguido de 1-50 letras/números/_ unicode
const TOKEN_REGEX = /(\b(?:https?:\/\/|www\.)[^\s<>"]+?)(?=[.,;:!?)>\]]*(?:\s|$))|(#[\p{L}\p{N}_]{1,50})/gu;

function isChannelLink(href) {
    try {
        const u = new URL(href.startsWith('http') ? href : `https://${href}`);
        return /^\/c\/(@?[A-Za-z0-9_-]+)$/.test(u.pathname);
    } catch { return false; }
}

function getChannelCode(href) {
    try {
        const u = new URL(href.startsWith('http') ? href : `https://${href}`);
        const m = u.pathname.match(/^\/c\/(@?[A-Za-z0-9_-]+)$/);
        return m ? m[1] : null;
    } catch { return null; }
}

export function linkify(text) {
    if (!text || typeof text !== 'string') return text;
    const parts = [];
    let lastIndex = 0;
    let m;
    TOKEN_REGEX.lastIndex = 0;
    while ((m = TOKEN_REGEX.exec(text)) !== null) {
        const start = m.index;
        if (start > lastIndex) parts.push(text.slice(lastIndex, start));

        const urlMatch = m[1];
        const hashtagMatch = m[2];

        if (hashtagMatch) {
            const tag = hashtagMatch.slice(1).toLowerCase();
            parts.push(
                <a
                    key={`h${start}`}
                    href={`#${tag}`}
                    onClick={(e) => {
                        e.preventDefault();
                        window.dispatchEvent(new CustomEvent('open_hashtag', { detail: { tag } }));
                    }}
                    className="msg-link msg-link-hashtag"
                >{hashtagMatch}</a>
            );
            lastIndex = start + hashtagMatch.length;
            continue;
        }

        const matched = urlMatch;
        const href = matched.startsWith('http') ? matched : `https://${matched}`;
        if (isChannelLink(href)) {
            const code = getChannelCode(href);
            parts.push(
                <a
                    key={`l${start}`}
                    href={href}
                    onClick={(e) => {
                        e.preventDefault();
                        window.dispatchEvent(new CustomEvent('open_channel_profile', { detail: { inviteCode: code } }));
                    }}
                    className="msg-link msg-link-channel"
                >📢 {matched}</a>
            );
        } else {
            parts.push(
                <a
                    key={`l${start}`}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="msg-link"
                >{matched}</a>
            );
        }
        lastIndex = start + matched.length;
    }
    if (lastIndex < text.length) parts.push(text.slice(lastIndex));
    return parts.length ? parts : text;
}
